import { call, put, takeEvery, actionChannel } from 'redux-saga/effects';

import { actions } from '@tvguide/store/actions/requests';
import { updateProgram } from '@store/actions/programs';
import API from '@api';

function* fetchProgramDetails(action) {
  try {
    const program = yield call(
      API.getProgramDetails.bind(API),
      action.sid,
      action.nid,
      action.pid,
      action.start_time,
      action.duration,
    );
    delete program.service_id;
    delete program.uuid;
    delete program.duration;
    yield put(
      updateProgram(action.sid, action.id, {
        ...program,
        requesting: false,
      }),
    );
  } catch (e) {
    yield put(
      updateProgram(action.sid, action.id, {
        requesting: false,
      }),
    );
  }
}

function* programDetailSaga() {
  const channel = yield actionChannel(actions.programDetails);
  yield takeEvery(channel, fetchProgramDetails);
}

export default programDetailSaga;
